import {
   randNumber,
   randProductAdjective,
   randProductCategory,
   randFullName,
   randBoolean,
   randRecentDate,
} from '@ngneat/falso';
import { ShipmentFactory } from '@library/common/models/mock';
import { Template } from './template';

export class MockTemplate extends Template {
   constructor() {
      super();

      this.id = randNumber({ max: 100 });
      this.name = randProductAdjective() + ' ' + randProductCategory();
      this.owner_name = randFullName();
      this.last_updated = randRecentDate().toISOString().slice( 0, 10 );
      this.shared = randBoolean();
      this.owned = true;

      this.data = ShipmentFactory.mock();
   }
}
